import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  emptyStringAsUndefined: true,
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,

  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    VERIFY_EMAIL_BASE_URL: process.env.VERIFY_EMAIL_BASE_URL,
    DATABASE_URL: process.env.DATABASE_URL,
    STORAGE_BUCKET_NAME: process.env.STORAGE_BUCKET_NAME,
    NEXT_PUBLIC_STORAGE_BASE_URL: process.env.NEXT_PUBLIC_STORAGE_BASE_URL,
    NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
    NEXT_PUBLIC_FACEBOOK_PIXEL_ID: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID,
    ADMIN_NOTIFICATION_EMAIL: process.env.ADMIN_NOTIFICATION_EMAIL,
    DASHBOARD_BASE_URL: process.env.DASHBOARD_BASE_URL,
  },

  server: {
    STORAGE_BUCKET_NAME: z.string(),
    DATABASE_URL: z.string().url(),
    VERIFY_EMAIL_BASE_URL: z.string().url(),
    NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),
    ADMIN_NOTIFICATION_EMAIL: z.string().email().optional(),
    DASHBOARD_BASE_URL: z.string().url().optional(),
  },

  client: {
    NEXT_PUBLIC_STORAGE_BASE_URL: z.string().url(),
    NEXT_PUBLIC_GA_ID: z.string(),
    NEXT_PUBLIC_FACEBOOK_PIXEL_ID: z.string(),
  },
});
